var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/","aria-label":"home"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/logo.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }